import { createApp } from "vue";
import { createHead } from "@vueuse/head";
import App from "./App.vue";
import router from "./router/index.js";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/Css/sweetalert-overrides.css";
import printerBridge from './assets/Js/print-bridge.js';
// ✅ 導入 SignalR 服務
import signalRService from './assets/Js/signalR.js';

const app = createApp(App);
const head = createHead();

// ✅ 創建 SignalR 插件
const signalRPlugin = {
  install(app) {
    // 將 SignalR 服務掛載到全局屬性
    app.config.globalProperties.$signalR = signalRService;
    
    // 也可以使用 provide/inject 方式
    app.provide('signalR', signalRService);
  }
};

const printerPlugin = {
  install(app) {
    app.config.globalProperties.$printer = printerBridge;
    app.provide('printer', printerBridge);
  }
};

app.use(router);
app.use(head);
app.use(signalRPlugin); // ✅ 使用 SignalR 插件
app.use(printerPlugin);

app.mount("#app");